export class InlineCompletionsAccessibleView {
}
